import { connect } from 'react-redux';
import { isFeedbackSubmitted } from 'project/ducks/wrapup';
import Sidebar from 'project/components/wrapup/sidebar';

const mapStateToProps = (state, { wrapup }) => {
  const user = state.user.profile_data;

  return {
    feedbackSubmitted: isFeedbackSubmitted(wrapup, user),
    isAdmin: user.is_staff
  };
};

export default connect(mapStateToProps)(Sidebar);



// WEBPACK FOOTER //
// ./project/containers/wrapup/sidebar.js